import { jsonldLinkedin } from './JsonldStore';

export const updateJsonldLinkedin = (value) => jsonldLinkedin.update((oldValue) => value);
